import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { class: "p-d-flex p-flex-row p-ai-center" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QBEOperand = _resolveComponent("QBEOperand")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.node?.childNodes)
        ? (_openBlock(), _createBlock(_component_QBEOperand, {
            key: 0,
            propNode: _ctx.node.childNodes[0],
            onSelectedChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selectedChanged'))),
            onTreeUpdated: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('treeUpdated')))
          }, null, 8, ["propNode"]))
        : _createCommentVNode("", true),
      (_ctx.node)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.node?.childNodes && _ctx.node.childNodes.length > 0)
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  class: ["kn-material-input p-mx-2", { 'dropdown-test': _ctx.selected }],
                  style: { maxWidth: '200px' },
                  modelValue: _ctx.node.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.node.value = $event)),
                  options: _ctx.QBEAdvancedFilterDialogDescriptor.operatorOptions
                }, null, 8, ["class", "modelValue", "options"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.node?.childNodes)
        ? (_openBlock(), _createBlock(_component_QBEOperand, {
            key: 2,
            propNode: _ctx.node?.childNodes[1],
            onSelectedChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('selectedChanged'))),
            onTreeUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('treeUpdated')))
          }, null, 8, ["propNode"]))
        : _createCommentVNode("", true)
    ])
  ]))
}